import React from "react";
import { Redirect } from "react-router-dom";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import NewPwd from "../pages/Authentication/NewPassword";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

//Companies
import Companies from "../pages/Companies/Companies";
import NewCompany from "../pages/Companies/Company";

//Users
import Users from "../pages/Users/Users";
import NewUsers from "../pages/Users/User";

//SystemUsers
import SystemUsers from "../pages/SystemUsers/SystemUsers";
import NewSystemUser from "../pages/SystemUsers/SystemUser";

//Profiles
import Profiles from "../pages/Profiles/Profiles";
import newProfile from "../pages/Profiles/Profile";

//Roles
import Roles from "../pages/Roles/Roles";
import Role from "../pages/Roles/Role";

//Edi Profile
import EditProfile from "../pages/EditProfile/EditProfile";

//Departments
import Departments from "../pages/Departments/Departments";
import NewDepartment from "../pages/Departments/Department";

// Inner Authentication
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";

//Insights
import Insights from "../pages/Insights/Insights";
import Insight from "../pages/Insights/Insight";

//ClientSystems
import ClientSystems from "../pages/ClientSystemVariables/ClientSystemVariables";
import ClientSystem from "../pages/ClientSystemVariables/ClientSystemVariable";

//SystemVariables
import ClientSystemVariables from "../pages/SystemVariables/SystemVariables";
import ClientSystemVariable from "../pages/SystemVariables/SystemVariable";

const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },

  //Profiles
  { path: "/profiles", component: Profiles },
  { path: "/profile/:idProfile", component: newProfile },
  { path: "/profile", component: newProfile },
  {
    path: "/company/:idCompany/profile/:idProfile",
    component: newProfile,
  },
  { path: "/company/:idCompany/profile", component: newProfile },

  //Departments
  { path: "/departments", component: Departments },
  {
    path: "/company/:idCompany/department/:idDepartment",
    component: NewDepartment,
  },
  { path: "/company/:idCompany/department", component: NewDepartment },

  //Users
  { path: "/users", component: Users },
  { path: "/company/:idCompany/user/:idUser", component: NewUsers },
  { path: "/company/:idCompany/users", component: Users },
  { path: "/company/:idCompany/user", component: NewUsers },

  //Companies
  { path: "/companies", component: Companies },
  { path: "/company/:idCompany", component: NewCompany },
  { path: "/company", component: NewCompany },

  //SystemUsers
  { path: "/systemusers", component: SystemUsers },
  { path: "/systemuser/:idSystemUser", component: NewSystemUser },
  { path: "/systemuser", component: NewSystemUser },

  //Roles
  { path: "/roles", component: Roles },
  { path: "/role/:idRole", component: Role },
  { path: "/role", component: Role },

  //Edit Profile
  { path: "/edit-profile", component: EditProfile },

  //Insights
  { path: "/insights", component: Insights },
  { path: "/insight/:idInsight", component: Insight },
  { path: "/insight", component: Insight },

  //ClientSystems
  { path: "/clientsystemvariables", component: ClientSystems },
  { path: "/clientsystemvariable/:idClientSystem", component: ClientSystem },
  { path: "/clientsystemvariable", component: ClientSystem },

  //SystemVariables
  { path: "/systemvariables", component: ClientSystemVariables },
  {
    path: "/systemvariable/:idClientSystemVariable",
    component: ClientSystemVariable,
  },
  { path: "/systemvariable", component: ClientSystemVariable },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
];

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/reset-password/:token", component: NewPwd },
  { path: "/register", component: Register },

  // Authentication Inner
  { path: "/auth-lock-screen", component: LockScreen },
];

export { authProtectedRoutes, publicRoutes };
